import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './NormalModal.module.scss';
import { useModalStore } from '../../store/NormalModalStore';
import { useTasksStore } from '../../store/BoostMaxTasksStore';

interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({ children }) => {
  const open = useModalStore((state) => state.open);
  const closing = useModalStore((state) => state.closing);
  const setOpen = useModalStore((state) => state.setOpen);
  const setClosing = useModalStore((state) => state.setClosing);
  const [isVisible, setIsVisible] = useState(false);
  const showDelayedNotification = useTasksStore(
    (state) => state.showDelayedNotification,
  );

  useEffect(() => {
    if (open === true || open === 'boost' || open === 'dailyReward') {
      setIsVisible(true);
    }
  }, [open]);

  useEffect(() => {
    if (closing) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setOpen(false);
        setClosing(false);

        // Показываем отложенные уведомления после закрытия модалки
        if (open === 'dailyReward') {
          setTimeout(() => {
            showDelayedNotification();
          }, 100);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [closing, setOpen, setClosing, open, showDelayedNotification]);

  const handleClose = () => {
    setClosing(true);
  };

  // Если модалка не видима - не рендерим ничего
  if (!isVisible) {
    return null;
  }

  const modalContainer = `${styles.modal} ${closing ? styles.slideDown : ''}`;

  const modalContent = (
    <div className={`${styles.modalWrapper} ${closing ? styles.closing : ''}`}>
      <div className={modalContainer} data-modal={open}>
        <div className={styles.modalContent}>
          <button className={styles.closeButton} onClick={handleClose}></button>
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;
